import type VideoChapter from '../types/VideoChapter'
import { getAssetUrl } from '../utils/assetUtils'
import videoMetadata from './videoMetadata.json'

const getFilesize = (path: string): number => {
  return videoMetadata[path]?.size || 0
}

const miniHelper = (chapter: number) => {
  return {
    standard: {
      chapter,
      type: 'standard',
      path: getAssetUrl(`/videos/chapter-${chapter}.mp4`),
      filesize: getFilesize(`/videos/chapter-${chapter}.mp4`),
    },
    avStandard: {
      chapter,
      type: 'av1-standard',
      path: getAssetUrl(`/videos/chapter-${chapter}-av1.mp4`),
      filesize: getFilesize(`/videos/chapter-${chapter}-av1.mp4`),
    },
    mobile: {
      chapter,
      type: 'mobile',
      path: getAssetUrl(`/videos/mobile-chapter-${chapter}.mp4`),
      filesize: getFilesize(`/videos/mobile-chapter-${chapter}.mp4`),
    },
    avMobile: {
      chapter,
      type: 'av1-mobile',
      path: getAssetUrl(`/videos/mobile-chapter-${chapter}-av1.mp4`),
      filesize: getFilesize(`/videos/mobile-chapter-${chapter}-av1.mp4`),
    },
    vp9Standard: {
      chapter,
      type: 'vp9-standard',
      path: getAssetUrl(`/videos/chapter-${chapter}-vp9.webm`),
      filesize: getFilesize(`/videos/chapter-${chapter}-vp9.webm`),
    },
    vp9Mobile: {
      chapter,
      type: 'vp9-mobile',
      path: getAssetUrl(`/videos/mobile-chapter-${chapter}-vp9.webm`),
      filesize: getFilesize(`/videos/mobile-chapter-${chapter}-vp9.webm`),
    },
  }
}

export default [
  {
    id: 'chapter1',
    title: 'Chapter 1',
    ...miniHelper(1),
    englishAudio: getAssetUrl('/audio/chapter-1-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-1-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-1-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-1-maori.vtt'),
  },
  {
    id: 'chapter2',
    title: 'Chapter 2',
    ...miniHelper(2),
    englishAudio: getAssetUrl('/audio/chapter-2-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-2-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-2-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-2-maori.vtt'),
  },
  {
    id: 'chapter3',
    title: 'Chapter 3',
    ...miniHelper(3),
    hasHotspots: true,
    englishAudio: getAssetUrl('/audio/chapter-3-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-3-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-3-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-3-maori.vtt'),
  },
  {
    id: 'chapter4',
    title: 'Chapter 4',
    ...miniHelper(4),
    englishAudio: getAssetUrl('/audio/chapter-4-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-4-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-4-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-4-maori.vtt'),
  },
  {
    id: 'chapter5',
    title: 'Chapter 5',
    ...miniHelper(5),
    englishAudio: getAssetUrl('/audio/chapter-5-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-5-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-5-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-5-maori.vtt'),
  },
  {
    id: 'chapter6',
    title: 'Chapter 6',
    ...miniHelper(6),
    hasHotspots: true,
    englishAudio: getAssetUrl('/audio/chapter-6-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-6-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-6-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-6-maori.vtt'),
  },
  {
    id: 'chapter7',
    title: 'Chapter 7',
    ...miniHelper(7),
    englishAudio: getAssetUrl('/audio/chapter-7-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-7-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-7-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-7-maori.vtt'),
  },
  {
    id: 'chapter8',
    title: 'Chapter 8',
    ...miniHelper(8),
    englishAudio: getAssetUrl('/audio/chapter-8-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-8-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-8-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-8-maori.vtt'),
  },
  {
    id: 'chapter9',
    title: 'Chapter 9',
    ...miniHelper(9),
    hasHotspots: true,
    englishAudio: getAssetUrl('/audio/chapter-9-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-9-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-9-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-9-maori.vtt'),
  },
  {
    id: 'chapter10',
    title: 'Chapter 10',
    ...miniHelper(10),
    hasHotspots: true,
    englishAudio: getAssetUrl('/audio/chapter-10-english.mp3'),
    englishSubtitle: getAssetUrl('/subtitles/chapter-10-english.vtt'),
    maoriAudio: getAssetUrl('/audio/chapter-10-maori.mp3'),
    maoriSubtitle: getAssetUrl('/subtitles/chapter-10-maori.vtt'),
  },
] as VideoChapter[]
